"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = passRecovery;

var _constants = require('redux/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    preload: false,
    step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1,
    error: '',
    is_send_voice_code: false,
    phone: '',
    timerRepeat: 30,
    errorCode: null
};

function passRecovery() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                error: '',
                errorCode: null
            });

        case _constants.VoiceCodeConstants.VOICE_CODE_FORM_FAIL:
            return (0, _extends3.default)({}, state, {
                error: action.error.title,
                is_send_voice_code: false,
                errorCode: action.error.code
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_REQUEST:
            return (0, _extends3.default)({}, state, {
                preload: true,
                error: null,
                errorCode: null
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_2,
                preload: false,
                error: null,
                errorCode: null
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_FORM_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                errorCode: action.error.code
            });

        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_REQUEST:
            return (0, _extends3.default)({}, state, {
                preload: true,
                error: null,
                errorCode: null
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_SUCCESS:
            return (0, _extends3.default)({}, state, {
                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_3,
                preload: false,
                error: null,
                errorCode: null
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_CONFIRM_FAIL:
            return (0, _extends3.default)({}, state, {
                preload: false,
                error: action.error.title,
                errorCode: action.error.code
            });

        case _constants.PassRecoveryConstants.PASS_RECOVERY_RESET_STEP:
            return (0, _extends3.default)({}, state, {
                step: _constants.PassRecoveryConstants.PASS_RECOVERY_STEP_1,
                preload: false,
                error: null,
                errorCode: null
            });

        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_REQUEST:
        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_FAIL:
        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_RESET:
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: false
            });
        case _constants.PassRecoveryConstants.PASS_RECOVERY_VOICE_FORM_SUCCESS:
            //Если телефон не в белом списке
            var inWhiteList = action.result.sendingStatus ? true : "not_white";
            return (0, _extends3.default)({}, state, {
                is_send_voice_code: inWhiteList,
                timerRepeat: action.result.timeToRepeat
            });

        case _constants.PassRecoveryConstants.PASS_RECOVERY_SET_PHONE:
            return (0, _extends3.default)({}, state, {
                phone: action.phone
            });

        case _constants.PassRecoveryConstants.PASS_RECOVERY_SHOW_ERROR:
            return (0, _extends3.default)({}, state, {
                error: action.error.title,
                errorCode: action.error.code
            });

        default:
            return state;
    }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/reducers/pass_recovery.js
// module id = 1907
// module chunks = 0